import type { KnownUserRanklists } from "@src/gql/graphql";

export const checkRankingsValid = (
	whiteboards: {
		ranking?: Array<{ itemKey: string; itemRank?: string | null }>;
	}[],
) => {
	const seenRankings = new Set<string>();
	let hasDuplicateRankings = false;
	let hasEmptyRankings = false;

	for (const whiteboard of whiteboards) {
		const rankings = whiteboard.ranking ?? [];
		if (rankings.length > 1) {
			for (const ranking of rankings) {
				if (seenRankings.has(ranking.itemKey)) {
					hasDuplicateRankings = true;
					break;
				}

				seenRankings.add(ranking.itemKey);
			}
			break;
		}

		if (
			rankings.length === 0 ||
			rankings.some(
				(ranking) =>
					ranking.itemRank === null ||
					ranking.itemRank === undefined ||
					ranking.itemRank === "",
			)
		) {
			hasEmptyRankings = true;
			break;
		}
	}

	return {
		hasDuplicateRankings,
		hasEmptyRankings,
	};
};

export async function ensureValidRankings<
	T extends {
		id: string;
		ranking?: Array<{ itemKey: string; itemRank?: string | null }>;
	},
>(whiteboards: T[], _: KnownUserRanklists): Promise<T[]> {
	const { hasDuplicateRankings, hasEmptyRankings } =
		checkRankingsValid(whiteboards);
	if (hasDuplicateRankings || hasEmptyRankings) {
		console.warn(
			"Invalid rankings: hasDuplicateRankings",
			hasDuplicateRankings,
			"hasEmptyRankings",
			hasEmptyRankings,
		);
	}

	return whiteboards;
}
